/**
 * @file api-nav-counters.ts
 * @description Счётчики меню кабинета магазина одним запросом (phase19.31,
 * SC18, SC41; cabinet-api-contract.md §6).
 *
 *   GET /admin/nav-counters → `{ ordersAttention?, reviewsPending?,
 *   chatUnread?, pickingQueue? }` — поле приходит, только если у роли есть
 *   право на раздел. Кабинет платформы — 403 `rbac_shop_only`. Сервер
 *   кэширует ответ на 30 секунд.
 */

import { apiFetch } from "./api-client";
import type { NavCounters } from "./shop-nav";

export function getNavCounters(): Promise<NavCounters> {
  return apiFetch<NavCounters>("/admin/nav-counters");
}
